var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.survey)?_c('Survey',{attrs:{"survey":_vm.survey}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }